// Single source of truth for the free-trial window.
// Referenced by JobComponent (billing gate) and OnboardingStateService (cohort logic).
export const FREE_TRIAL_DAYS: number = 15;
